import React from "react";
import patternImg from "../../assets/img/pattern.png";
import { Link } from "react-router-dom";

const Serve = () => {
  return (
    <section
      className="wrapper pattern-wrapper bg-image section-frame"
      // data-image-src=""
      style={{ backgroundImage: `url(${patternImg})` }}
    >
      <div className="container pt-15 pt-md-17 ">
        <div
          className="row gx-lg-0 gy-10 align-items-center pb-15 pb-md-17"
          // data-aos="zoom-in"
        >
          <div className="col-lg-6 order-lg-2 ms-lg-auto">
            <div className="card rounded-xl me-lg-6 bg-pale-grape">
              <div className="card-body p-6">
                <div className="d-flex flex-row">
                  <div>
                    <span className="icon btn btn-block btn-lg shadow-xl rounded-xl btn-white pe-none me-4">
                      <span className="number text-grape">01</span>
                    </span>
                  </div>
                  <div>
                    <h3 className="mb-1 text-grape">Product Thinking</h3>
                    <p className="mb-0">
                      We challenge assumptions and focus on the outcomes that
                      matter to your users and your business.
                    </p>
                  </div>
                </div>
              </div>
              {/*/.card-body */}
            </div>
            {/*/.card */}
            <div className="card rounded-xl ms-lg-13 mt-6 bg-pale-fuchsia">
              <div className="card-body p-6">
                <div className="d-flex flex-row">
                  <div>
                    <span className="icon btn btn-block btn-lg shadow-xl rounded-xl btn-white pe-none me-4">
                      <span className="number text-fuchsia">02</span>
                    </span>
                  </div>
                  <div>
                    <h3 className="mb-1 text-fuchsia">
                      Radical Transparency
                    </h3>
                    <p className="mb-0">
                      Clear estimates, weekly demos and direct access to the
                      engineers building your product.
                    </p>
                  </div>
                </div>
              </div>
              {/*/.card-body */}
            </div>
            {/*/.card */}
            <div className="card rounded-xl mx-lg-6 mt-6 bg-pale-green">
              <div className="card-body p-6">
                <div className="d-flex flex-row">
                  <div>
                    <span className="icon btn btn-block btn-lg shadow-xl rounded-xl btn-white pe-none me-4">
                      <span className="number text-green">03</span>
                    </span>
                  </div>
                  <div>
                    <h3 className="mb-1 text-green">Long-term Partnership</h3>
                    <p className="mb-0">
                      We stay after launch — supporting, scaling and evolving
                      your product as your business grows.
                    </p>
                  </div>
                </div>
              </div>
              {/*/.card-body */}
            </div>
            {/*/.card */}
          </div>
          {/*/column */}
          <div className="col-lg-5 text-inverse">
            <h2 className="display-2 mb-3 text-white">
              Why clients choose Dobedo Soft
            </h2>
            <p className="lead fs-lg pe-lg-5">
              A senior, product-minded team that treats your roadmap like our
              own.
            </p>
            <p>
              We combine modern engineering with practical AI expertise to ship
              secure, scalable software — with the clear communication and
              ownership you'd expect from an in-house team.
            </p>
            <Link
              to="/contact-us"
              className="btn btn-white rounded-xl mb-0 contact-us-button text-white"
            >
              Start a project
            </Link>
          </div>
          {/*/column */}
        </div>
        {/*/.row */}
      </div>
      {/* /.container */}
    </section>
  );
};

export default Serve;
